export default "__VITE_ASSET__XAEK5uKS__"